var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _g5, _path0, _g6, _path1, _path10, _g7, _path11, _path12, _g8, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g9, _path22, _path23, _path24, _path25, _g0, _path26, _path27, _path28, _path29, _g1, _path30, _path31, _path32, _path33, _g10, _path34, _path35, _path36, _path37, _g11, _path38, _path39, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationUnify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 194,
    viewBox: "0 0 200 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.188 86.8573C194.794 64.7117 185.184 43.2601 168.253 27.3532C151.241 11.3696 128.24 0.806996 102.352 0.0442267C98.9213 -0.0573377 95.5223 0.0169959 92.1621 0.25722C45.7568 3.56589 7.05981 38.6042 0.856595 83.6279C-6.41466 136.421 33.608 183.918 82.8563 191.526C144.11 200.989 212.017 177.12 198.188 86.8573Z",
    fill: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 70,
    width: 64,
    height: 99
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6165 70.4844H2.49316V168.568H65.6165V70.4844Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4226_12486)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 130,
    width: 96,
    height: 87
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.268 206.181L95.5498 216.835C95.5498 216.835 87.3138 211.29 87.0637 203.351C86.5534 187.152 72.4016 188.73 66.3754 188.504C57.2874 188.163 49.4274 183.899 55.8993 174.881C62.3712 165.863 44.2299 158.848 29.4736 160.413C15.0334 161.944 3.9789 137.159 34.9285 130.975C53.4115 127.282 61.8914 143.574 68.1297 150.784C74.3679 157.993 86.2714 150.347 89.1587 162.581C91.6249 173.031 89.5066 183.485 98.3524 185.494C107.198 187.502 112.18 193.327 110.268 206.181Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4226_12486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.268 206.181L95.5498 216.835C95.5498 216.835 87.3138 211.29 87.0637 203.351C86.5534 187.152 72.4016 188.73 66.3754 188.504C57.2874 188.163 50.4845 184.147 54.7066 175.292C59.4835 165.272 44.23 158.848 29.4736 160.413C15.0334 161.944 3.9789 137.159 34.9285 130.975C53.4115 127.282 61.8914 143.574 68.1297 150.784C74.3679 157.993 86.2714 150.347 89.1587 162.581C91.6249 173.031 89.5066 183.485 98.3524 185.494C107.198 187.502 112.18 193.327 110.268 206.181Z",
    fill: "url(#paint0_linear_4226_12486)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 130,
    width: 96,
    height: 87
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.268 206.181L95.5498 216.835C95.5498 216.835 87.3138 211.29 87.0637 203.351C86.5534 187.152 72.4016 188.73 66.3754 188.504C57.2874 188.163 49.4274 183.899 55.8993 174.881C62.3712 165.863 44.2299 158.848 29.4736 160.413C15.0334 161.944 3.9789 137.159 34.9285 130.975C53.4115 127.282 61.8914 143.574 68.1297 150.784C74.3679 157.993 86.2714 150.347 89.1587 162.581C91.6249 173.031 89.5066 183.485 98.3524 185.494C107.198 187.502 112.18 193.327 110.268 206.181Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4226_12486)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.887 212.157L104.541 212.322C104.438 212.108 94.1162 190.677 77.4775 172.518C62.1489 155.789 38.1666 138.493 10.9641 151.102L10.8027 150.754C22.912 145.141 35.4002 144.885 47.9206 149.992C57.9222 154.072 67.9635 161.566 77.7656 172.265C94.4411 190.466 104.784 211.942 104.887 212.157Z",
    fill: "#4338CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0602 152.354L52.7239 152.539C46.5729 141.351 32.1106 129.603 31.9653 129.486L32.2061 129.188C32.3522 129.305 46.8731 141.101 53.0602 152.354Z",
    fill: "#4338CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6245 149.18C29.4472 150.234 21.9381 160.435 21.8641 160.538L21.5527 160.314C21.6278 160.21 29.2346 149.864 44.5979 148.797L44.6245 149.18Z",
    fill: "#4338CA"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0413 153.182C50.4491 156.972 52.3809 160.459 54.1741 162.763C54.5679 162.732 54.8024 162.814 55.2053 162.87C58.8422 163.375 60.5013 162.815 64.1645 162.747C64.953 162.732 67.2543 161.985 68.1749 161.62L69.8805 160.911C69.8805 160.911 72.4491 151.805 67.4593 149.781C62.4696 147.756 63.8119 138.798 63.9382 133.965C64.0157 130.997 63.1004 129.615 62.9538 128.519C61.4021 116.926 64.6558 113.216 61.8354 109.757C58.7219 105.937 53.8655 109.365 50.259 105.389C46.1866 100.9 49.6449 93.514 44.8416 90.1265C44.0182 89.5457 43.1562 88.9714 41.8418 88.6902C38.5973 87.9959 36.1554 90.038 33.6955 87.5946C28.7511 82.6833 21.1195 81.4265 16.9556 87.2783C12.8462 93.0538 18.8489 103.328 32.7172 110.806C41.9733 117.249 42.2374 119.394 41.8485 124.706C41.5763 128.427 38.373 138.335 43.9505 141.701C49.528 145.066 53.8616 148.849 52.0413 153.182Z",
    fill: "url(#paint1_linear_4226_12486)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 83,
    width: 56,
    height: 83
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6773 165.538L69.6064 161.257C69.6064 161.257 72.449 151.805 67.4593 149.78C62.4696 147.756 63.8119 138.798 63.9381 133.965C64.2807 120.851 49.265 123.334 48.2653 106.5C47.9994 102.023 49.0975 93.3441 44.8416 90.1265C39.9929 86.4607 36.859 90.7368 33.6955 87.5946C28.7511 82.6833 21.1194 81.4265 16.9556 87.2783C12.8462 93.0538 18.849 103.328 32.7171 110.806C41.9734 117.249 42.2374 119.394 41.8486 124.706C41.5762 128.427 38.3731 138.335 43.9505 141.701C49.528 145.066 53.8614 148.849 52.0412 153.181C49.2715 159.774 56.6773 165.538 56.6773 165.538Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4226_12486)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2724 163.048L62.537 162.994C62.2527 161.531 61.9465 160.059 61.6269 158.62C59.2602 147.963 55.9064 137.935 51.6583 128.817C48.0588 121.09 43.7684 113.906 38.9065 107.464C34.9965 102.284 30.6972 97.5533 26.1281 93.4036C22.916 90.4865 19.6048 87.8844 16.2863 85.6699C15.708 85.2839 15.0924 84.9203 14.4969 84.5685C13.7036 84.0999 12.8833 83.6154 12.1453 83.0742L11.9746 83.2743C12.7227 83.8231 13.5485 84.3109 14.3473 84.7827C14.9398 85.1326 15.5524 85.4945 16.1247 85.8766C19.4328 88.084 22.7342 90.6783 25.9371 93.5872C30.4949 97.7266 34.7839 102.446 38.6849 107.615C43.5368 114.043 47.8186 121.213 51.4113 128.924C55.6522 138.028 59.0006 148.039 61.3636 158.68C61.6828 160.117 61.9885 161.587 62.2724 163.048Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2433 115.692L44.4802 115.565C39.0179 106.257 42.2663 87.9125 42.2998 87.7283L42.0348 87.6953C42.0011 87.8804 38.7373 106.31 44.2433 115.692Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0308 143.068L57.2808 142.966C54.3769 136.207 40.0625 132.03 39.9183 131.988L39.8306 132.229C39.9737 132.27 54.1724 136.414 57.0308 143.068Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3185 147.047L58.582 146.988C57.5639 142.302 58.8751 135.307 62.274 127.293C62.4449 126.89 62.4449 126.89 62.4356 126.844L62.1713 126.9L62.3034 126.872L62.1721 126.852C62.164 126.88 62.0995 127.032 62.0246 127.208C58.6063 135.268 57.29 142.313 58.3185 147.047Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7133 160.385L61.9506 160.259C59.2836 155.669 51.0141 154.48 50.9309 154.469L50.8818 154.718C50.9638 154.729 59.1073 155.901 61.7133 160.385Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.679 163.032C63.4479 158.787 65.5377 154.564 69.0678 150.122L68.8541 149.977C65.297 154.453 63.1905 158.713 62.4141 162.999L62.679 163.032Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5836 96.0731L28.8129 95.934C25.461 90.9287 23.2104 84.8991 22.4709 82.9178C22.2918 82.4382 22.2282 82.2696 22.195 82.2148L21.96 82.3451C21.9847 82.3873 22.087 82.6614 22.2165 83.0086C22.9585 84.9962 25.2164 91.0449 28.5836 96.0731Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3522 103.409L35.5301 103.215C31.0123 99.6476 18.9872 100.811 18.4775 100.862L18.4963 101.112C18.62 101.1 30.9187 99.9089 35.3522 103.409Z",
    fill: "#FCFDFE"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1412 190.578C79.0123 190.242 76.8071 185.863 77.9569 179.276C78.2442 177.631 79.1884 168.547 85.7926 166.666C87.0746 166.301 88.3566 165.936 89.6385 165.571C90.0344 162.391 89.8183 159.321 85.6195 159.176C79.0989 158.952 76.5832 148.783 77.4229 144.757C78.4622 139.776 80.6351 128.137 70.5662 127.638C62.1839 127.223 56.6204 128.6 53.8517 119.165C51.083 109.729 44.1905 105.119 35.1717 107.949C25.6806 110.927 14.9638 100.72 8.01765 106.736C-4.08552 117.219 13.2608 135.233 31.3966 137.213C49.5323 139.192 41.2675 147.276 42.6332 155.22C42.8018 155.95 43.1194 157.069 43.7451 158.319C47.5972 166.013 56.4498 165.318 64.1801 170.488C74.7225 177.539 76.6736 191.144 78.1412 190.578Z",
    fill: "#4338CA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 104,
    width: 87,
    height: 70
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5103 173.385L89.4568 168.045C90.0002 164.922 90.3097 159.338 85.6196 159.176C79.0989 158.952 76.5833 148.783 77.423 144.757C78.4623 139.776 80.6351 128.137 70.5661 127.638C62.1838 127.223 56.6204 128.6 53.8517 119.164C51.0831 109.729 44.1905 105.119 35.1716 107.949C25.6807 110.927 14.9638 100.72 8.01768 106.736C-4.08556 117.219 13.2608 135.233 31.3965 137.213C49.5323 139.192 41.2675 147.276 42.6331 155.22C44.4976 166.065 59.2081 160.015 64.2081 163.221C68.1279 165.734 68.5964 170.423 68.5103 173.385Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4226_12486)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6213 167.745L78.0467 167.548C64.205 138.309 35.3392 116.192 2.71399 109.828L2.60449 110.265C35.0923 116.602 63.8371 138.627 77.6213 167.745Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9186 162.437L75.2702 162.132C66.3813 152.66 41.9653 157.122 41.7197 157.168L41.7925 157.605C42.0354 157.559 66.1986 153.145 74.9186 162.437Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1621 129.699L46.5387 129.423C40.2064 121.335 43.1786 105.703 43.2093 105.547L42.752 105.48C42.7207 105.639 39.7127 121.461 46.1621 129.699Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2407 118.79L28.3922 118.363C16.7992 114.976 1.78717 122.213 1.63672 122.287L1.83577 122.682C1.98422 122.609 16.8283 115.455 28.2407 118.79Z",
    fill: "#FCFDFE"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 56,
    width: 62,
    height: 108
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.158 161.524L158.21 163.594C158.21 163.594 162.67 154.724 158.995 147.681C151.498 133.313 164.606 127.749 169.747 124.598C177.501 119.845 182.261 112.276 172.199 107.589C162.137 102.902 174.51 87.8939 188.138 82.0232C201.475 76.2784 198.958 49.2565 168.951 59.0402C151.031 64.8829 151.628 83.2405 149.726 92.5825C147.823 101.924 133.7 101.096 137.181 113.174C140.155 123.491 147.126 131.564 140.401 137.652C133.676 143.739 132.191 151.258 140.158 161.524Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4226_12486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.158 161.524L158.21 163.594C158.21 163.594 162.67 154.724 158.995 147.681C151.498 133.313 164.606 127.749 169.747 124.598C177.501 119.845 181.462 113.01 173.44 107.362C164.365 100.971 174.51 87.894 188.138 82.0232C201.475 76.2784 198.958 49.2565 168.951 59.0402C151.031 64.8829 151.628 83.2405 149.726 92.5825C147.823 101.924 133.7 101.096 137.181 113.174C140.155 123.491 147.126 131.564 140.401 137.652C133.676 143.739 132.191 151.258 140.158 161.524Z",
    fill: "url(#paint2_linear_4226_12486)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 56,
    width: 62,
    height: 108
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M140.158 161.524L158.21 163.594C158.21 163.594 162.67 154.724 158.995 147.681C151.498 133.313 164.606 127.749 169.747 124.598C177.501 119.845 182.261 112.276 172.199 107.589C162.137 102.902 174.51 87.8939 188.138 82.0232C201.475 76.2784 198.958 49.2565 168.951 59.0402C151.031 64.8829 151.628 83.2405 149.726 92.5825C147.823 101.924 133.7 101.096 137.181 113.174C140.155 123.491 147.126 131.564 140.401 137.652C133.676 143.739 132.191 151.258 140.158 161.524Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4226_12486)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.779 164.097L148.161 164.071C148.145 163.834 146.636 140.095 152.235 116.111C157.393 94.0148 169.816 67.1828 199.706 64.8355L199.676 64.4531C186.37 65.4979 175.36 71.3972 166.952 81.987C160.235 90.4465 155.157 101.901 151.859 116.031C146.249 140.071 147.763 163.859 147.779 164.097Z",
    fill: "#4338CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.63 86.5639L164.013 86.56C163.889 73.7936 170.735 56.4641 170.804 56.2906L170.448 56.1484C170.378 56.3228 163.505 73.7227 163.63 86.5639Z",
    fill: "#4338CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.425 79.658C183.17 73.1363 194.716 78.3457 194.831 78.3991L194.993 78.0513C194.876 77.9969 183.174 72.7099 169.261 79.3114L169.425 79.658Z",
    fill: "#4338CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.428 131.988C155.75 114.509 180.692 112.905 180.936 112.91L180.969 112.528C180.729 112.5 155.445 114.224 149.068 131.858L149.428 131.988Z",
    fill: "#4338CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.184 124.363L150.566 124.328C149.489 112.517 137.886 103.144 137.768 103.051L137.529 103.351C137.645 103.443 149.122 112.717 150.184 124.363Z",
    fill: "#4338CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.006 160.327C149.358 153.397 159.977 149.004 160.084 148.961L159.94 148.605C159.495 148.786 149.021 153.119 147.63 160.254L148.006 160.327Z",
    fill: "#4338CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.573 154.71L147.956 154.689C147.649 149.115 140.084 142.077 137.597 139.764C137.246 139.437 136.943 139.155 136.899 139.094L136.585 139.314C136.646 139.401 136.847 139.589 137.336 140.044C139.794 142.331 147.275 149.29 147.573 154.71Z",
    fill: "#4338CA"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M147.771 91.4853C151.017 94.008 151.043 97.9945 150.61 100.882C150.251 101.048 150.087 101.234 149.763 101.481C146.841 103.704 145.12 104.029 141.894 105.766C141.2 106.14 138.828 106.617 137.846 106.75L136.012 106.968C136.012 106.968 129.309 100.291 132.665 96.0801C136.022 91.8697 130.46 84.7201 127.981 80.5693C126.458 78.0204 126.578 76.367 126.169 75.3406C121.838 64.4757 117.183 62.8372 117.945 58.4389C118.786 53.5836 124.699 54.1906 125.893 48.9571C127.242 43.0475 120.607 38.3059 123.132 32.9985C123.565 32.0886 124.035 31.1654 125.043 30.2759C127.53 28.0802 130.659 28.6628 131.606 25.3272C133.507 18.6226 139.542 13.7856 146.041 16.8446C152.454 19.8637 152.259 31.7615 143.838 45.0785C138.929 55.2317 139.751 57.2307 142.694 61.67C144.756 64.7796 152.405 71.8447 149.194 77.5124C145.983 83.1801 144.06 88.6015 147.771 91.4853Z",
    fill: "url(#paint3_linear_4226_12486)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 15,
    width: 29,
    height: 93
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 104.528L136.421 107.136C136.421 107.136 129.309 100.29 132.665 96.08C136.022 91.8695 130.46 84.72 127.98 80.5692C121.252 69.3071 135.557 64.1101 128.175 48.9477C126.212 44.9149 121 37.8894 123.132 32.9985C125.561 27.4263 130.389 29.6168 131.605 25.3272C133.507 18.6226 139.542 13.7857 146.04 16.8446C152.454 19.8637 152.259 31.7615 143.838 45.0784C138.929 55.2318 139.751 57.2306 142.694 61.67C144.755 64.7796 152.405 71.8448 149.194 77.5124C145.982 83.1801 144.06 88.6014 147.771 91.4853C153.417 95.8733 149.788 104.528 149.788 104.528Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_4226_12486)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.69 105.099L143.433 105.182C142.963 103.767 142.509 102.334 142.081 100.923C138.919 90.4741 136.926 80.0904 136.158 70.0601C135.507 61.5611 135.725 53.1963 136.804 45.1982C137.672 38.7662 139.1 32.5352 141.048 26.6784C142.417 22.5611 144.028 18.6699 145.834 15.1129C146.149 14.4929 146.507 13.8742 146.854 13.2757C147.316 12.4784 147.793 11.6538 148.171 10.8203L148.418 10.9111C148.035 11.756 147.554 12.5861 147.089 13.3889C146.744 13.9843 146.388 14.6001 146.076 15.2137C144.275 18.7596 142.67 22.6392 141.304 26.7448C139.361 32.5871 137.937 38.8033 137.071 45.2205C135.994 53.2022 135.777 61.5503 136.426 70.0329C137.193 80.0463 139.183 90.4135 142.34 100.846C142.767 102.255 143.221 103.686 143.69 105.099Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.187 54.9837L135.918 54.989C136.115 44.1992 124.29 29.8028 124.171 29.6587L124.386 29.5C124.506 29.6448 136.386 44.1075 136.187 54.9837Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.463 85.1126L138.195 85.1469C137.412 77.8318 147.84 67.1733 147.946 67.0664L148.14 67.2332C148.036 67.3391 137.692 77.9117 138.463 85.1126Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.293 89.216L139.034 89.2938C137.624 84.7103 133.052 79.257 126.16 73.9386C125.814 73.6711 125.814 73.6712 125.799 73.626L126.057 73.5452L125.928 73.5856L126.033 73.5039C126.054 73.5243 126.184 73.6253 126.336 73.7423C133.267 79.091 137.868 84.5862 139.293 89.216Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.873 102.505L142.604 102.512C142.678 97.2041 149.303 92.1133 149.37 92.0625L149.534 92.2553C149.469 92.3054 142.946 97.3194 142.873 102.505Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.328 105.285C140.577 101.962 136.685 99.306 131.43 97.1648L131.545 96.9336C136.84 99.0914 140.765 101.771 143.543 105.126L143.328 105.285Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.217 30.2084L139.949 30.1994C140.417 24.1936 139.422 17.835 139.096 15.7456C139.016 15.2398 138.989 15.0617 138.991 14.9977L139.26 14.9961C139.259 15.045 139.304 15.3341 139.362 15.7002C139.689 17.7963 140.687 24.1751 140.217 30.2084Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.916 39.923L137.666 39.8405C139.854 34.5166 150.905 29.635 151.375 29.4297L151.481 29.6568C151.367 29.7066 140.064 34.6985 137.916 39.923Z",
    fill: "#FCFDFE"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.762 130.407C152.838 130.541 152.613 125.643 148.382 120.466C147.325 119.173 142.048 111.719 135.37 113.317C134.074 113.628 132.777 113.938 131.481 114.248C129.577 111.671 128.26 108.889 131.849 106.704C137.422 103.312 134.629 93.2153 131.924 90.1188C128.575 86.2862 120.976 77.2076 129.507 71.8366C136.609 67.3652 142.133 65.8374 139.92 56.2566C137.708 46.6756 141.455 39.2782 150.703 37.3233C160.435 35.266 164.771 21.1153 173.775 22.9533C189.463 26.1563 183.176 50.3614 168.34 60.978C153.504 71.5946 164.671 74.5882 167.375 82.1814C167.586 82.9005 167.858 84.0316 167.925 85.4276C168.34 94.0219 160.283 97.756 156.081 106.052C150.349 117.366 155.319 130.181 153.762 130.407Z",
    fill: "#4338CA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 22,
    width: 58,
    height: 95
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.727 110.701L132.852 116.315C130.848 113.86 127.84 109.145 131.849 106.705C137.422 103.312 134.629 93.2153 131.924 90.1188C128.575 86.2863 120.976 77.2076 129.507 71.8365C136.609 67.3651 142.133 65.8375 139.92 56.2565C137.708 46.6756 141.455 39.2781 150.703 37.3232C160.435 35.266 164.771 21.1152 173.775 22.9533C189.463 26.1562 183.176 50.3613 168.34 60.9779C153.504 71.5945 164.671 74.5881 167.375 82.1812C171.067 92.5476 155.279 94.4864 152.493 99.7322C150.309 103.844 152.2 108.161 153.727 110.701Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_4226_12486)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.022 110.25L142.554 110.287C140.283 78.0171 154.599 44.5885 179.914 23.0469L180.224 23.3739C155.015 44.8248 140.76 78.1139 143.022 110.25Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.378 92.5301L142.927 92.6538C139.401 80.4319 125.54 73.9438 125.4 73.8796L125.611 73.4805C125.752 73.5452 139.797 80.1156 143.378 92.5301Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.775 104.298L142.319 104.205C145.423 91.5915 168.89 83.5098 169.127 83.4297L169.278 83.8464C169.044 83.9258 145.82 91.9246 142.775 104.298Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.788 61.6667L151.325 61.6109C152.878 51.4571 142.624 39.2903 142.521 39.1685L142.887 38.8867C142.992 39.0099 153.371 51.3253 151.788 61.6667Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.06 43.3742L161.719 43.0765C170.162 34.4405 186.794 33.3883 186.962 33.3789L186.982 33.8211C186.817 33.8303 170.372 34.8727 162.06 43.3742Z",
    fill: "#FCFDFE"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.802 52.1033C171.802 47.3118 169.002 43.3092 165.497 43.1627L36.317 37.7641C36.1722 37.7581 36.033 37.7563 35.8899 37.7591C33.1774 37.8116 30.8433 39.4302 29.4078 41.9157C28.5023 43.4835 28.0195 45.3963 28.0195 47.4822V54.707V168.09C28.0195 168.786 28.0334 169.457 28.1454 170.101C28.1734 170.263 28.1823 170.421 28.2168 170.579C28.3551 171.209 28.5338 171.809 28.7699 172.373C29.7736 174.773 31.6053 176.525 33.8367 177.151C34.6256 177.372 35.461 177.468 36.3292 177.386L136.073 168.057H136.072L165.497 165.281C169.002 164.953 171.802 160.787 171.802 155.996V58.3267V52.1033H171.802Z",
    fill: "#B7C0CE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M169.07 43.0843L39.4205 37.682C34.7841 37.4888 30.9951 41.8475 30.9951 47.4191V168.227C30.9951 173.798 34.7842 177.961 39.4205 177.528L169.07 165.412C172.588 165.083 175.42 160.927 175.42 156.126V52.0408C175.42 47.2404 172.588 43.2309 169.07 43.0843Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4205 174.33C36.2742 174.614 33.7002 171.774 33.7002 167.998V47.5032C33.7002 43.7265 36.2741 40.7533 39.4205 40.8747L169.07 45.8768C171.464 45.9691 173.402 48.704 173.402 51.9737V156.293C173.402 159.563 171.464 162.398 169.07 162.614L39.4205 174.33Z",
    fill: "#F4F7FA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.07 43.0843L39.4205 37.682C34.7842 37.4888 30.9951 41.8475 30.9951 47.4191V54.6559L175.42 58.2758V52.0408C175.42 47.2404 172.588 43.2309 169.07 43.0843Z",
    fill: "#D8DEE8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9304 46.6298C45.9304 48.2652 44.7197 49.5584 43.2224 49.5178C41.7206 49.4771 40.5 48.1112 40.5 46.467C40.5 44.8229 41.7206 43.5302 43.2224 43.5795C44.7197 43.6287 45.9304 44.9943 45.9304 46.6298Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3298 46.9135C55.3298 48.534 54.1412 49.8156 52.6712 49.7758C51.1969 49.7358 49.9985 48.3827 49.9985 46.7538C49.9985 45.1247 51.1969 43.8435 52.6712 43.892C54.1412 43.9402 55.3298 45.293 55.3298 46.9135Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5592 47.1901C64.5592 48.7959 63.392 50.0661 61.9484 50.027C60.5008 49.9878 59.3242 48.6474 59.3242 47.0332C59.3242 45.419 60.5008 44.1491 61.9484 44.1966C63.392 44.244 64.5592 45.5842 64.5592 47.1901Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M168.005 143.524L40.8096 152.325V147.22L168.005 139.047V143.524Z",
    fill: "#D8DEE8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M168.005 154.508L40.8096 164.851V159.746L168.005 150.031V154.508Z",
    fill: "#D8DEE8"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.575 102.396C105.546 75.7289 79.0093 84.8763 61.8706 54.6483C58.75 49.1445 56.6274 43.5274 55.1691 38.3382L39.4205 37.682C34.7842 37.4888 30.9951 41.8475 30.9951 47.4191V168.227C30.9951 173.798 34.7843 177.961 39.4205 177.528L139.516 168.173C136.661 163.216 134.017 157.626 131.775 151.323C123.128 127.023 129.539 118.3 120.575 102.396Z",
    fill: "white"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M158.538 154.761C146.608 156.131 136.601 147.088 136.601 134.558C136.601 122.029 146.608 111.313 158.538 110.688C170.077 110.085 179.189 119.204 179.189 130.999C179.189 142.793 170.077 153.436 158.538 154.761Z",
    fill: "url(#paint4_linear_4226_12486)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M159.982 155.198C148.07 156.569 138.078 147.535 138.078 135.015C138.078 122.495 148.07 111.784 159.982 111.157C171.504 110.552 180.603 119.662 180.603 131.448C180.603 143.234 171.504 153.871 159.982 155.198Z",
    fill: "url(#paint5_linear_4226_12486)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M179.22 131.565C179.22 142.578 170.738 152.465 159.982 153.68C148.887 154.934 139.632 146.536 139.632 134.886C139.632 123.236 148.887 113.285 159.982 112.677C170.738 112.089 179.22 120.552 179.22 131.565Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 114,
    width: 37,
    height: 39
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M177.831 131.679C177.831 141.897 169.953 151.053 159.982 152.159C149.721 153.296 141.18 145.517 141.18 134.753C141.18 123.989 149.721 114.777 159.982 114.193C169.953 113.626 177.831 121.461 177.831 131.679Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_4226_12486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.632 149.117C139.632 149.117 157.533 136.596 179.22 145.018C179.22 145.018 176.484 154.348 159.982 156.729C142.668 159.228 139.632 149.117 139.632 149.117Z",
    fill: "url(#paint6_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.841 133.439L156.176 138.607C155.948 140.371 154.783 141.943 153.159 142.671L147.713 145.11C147.713 145.11 158.11 149.196 171.086 142.745L165.192 141.208C163.512 140.721 162.366 139.188 162.293 137.324L162.123 132.996L156.841 133.439Z",
    fill: "url(#paint7_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.879 128.28C164.879 132.569 162.38 137.403 159.272 137.683C156.136 137.966 153.574 133.514 153.574 129.156C153.574 124.797 156.136 122.239 159.272 122.026C162.38 121.814 164.879 123.991 164.879 128.28Z",
    fill: "url(#paint8_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.759 124.635C160.071 124.847 157.51 125.454 155.731 127.513C152.738 130.979 154.16 135.98 152.828 136.399C151.639 136.774 149.795 133.28 149.825 129.268C149.85 125.907 150.968 121.871 153.873 120.683C155.574 119.987 156.075 120.901 161.54 121.09C164.71 121.199 163.468 122.755 164.181 123.253C167.338 125.459 166.939 133.483 165.24 133.73C164.433 133.847 163.318 131.849 161.759 124.635Z",
    fill: "black"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106.013 157.161C93.4318 158.584 82.8745 149.307 82.8745 136.437C82.8745 123.568 93.4318 112.553 106.013 111.905C118.178 111.278 127.783 120.633 127.783 132.741C127.783 144.85 118.178 155.786 106.013 157.161Z",
    fill: "url(#paint9_linear_4226_12486)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M107.536 157.608C94.9738 159.032 84.4326 149.764 84.4326 136.905C84.4326 124.045 94.9738 113.037 107.536 112.385C119.683 111.756 129.273 121.102 129.273 133.201C129.273 145.3 119.683 156.231 107.536 157.608Z",
    fill: "url(#paint10_linear_4226_12486)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M127.815 133.321C127.815 144.627 118.875 154.787 107.536 156.048C95.8347 157.349 86.0723 148.735 86.0723 136.769C86.0723 124.803 95.8347 114.576 107.536 113.945C118.875 113.333 127.815 122.016 127.815 133.321Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 115,
    width: 40,
    height: 40
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M126.351 133.441C126.351 143.931 118.048 153.341 107.536 154.488C96.7142 155.669 87.7051 147.689 87.7051 136.633C87.7051 125.577 96.7142 116.11 107.536 115.503C118.048 114.914 126.351 122.952 126.351 133.441Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_4226_12486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4174 168.024C83.6706 163.584 86.135 156.077 87.6846 152.663C92.1871 142.745 100.408 142.14 107.098 141.647C113.626 141.167 119.888 140.706 124.447 147.911C127.413 152.6 130.133 161.284 128.32 166.049C126.409 171.07 121.085 167.495 108.307 168.022C94.0621 168.61 87.5943 173.557 85.4174 168.024Z",
    fill: "url(#paint11_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.261 142.459C113.261 143.674 110.315 145.235 106.668 145.363C103.008 145.492 100.031 144.13 100.031 142.908C100.031 141.685 103.008 142.132 106.668 142.009C110.315 141.887 113.261 141.245 113.261 142.459Z",
    fill: "url(#paint12_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.232 134.254C103.223 134.284 105.55 141.317 101.883 142.415C101.527 142.522 101.469 143.002 101.792 143.167C102.778 143.669 104.622 144.283 107.639 144.178C109.595 144.11 111.022 143.32 111.763 142.794C112.016 142.614 111.991 142.234 111.72 142.103C110.598 141.558 109.038 139.757 109.503 134.279L104.232 134.254Z",
    fill: "url(#paint13_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.165 127.11C101.18 127.199 101.485 133.686 102.966 136.884C103.391 137.801 105.495 137.624 106.854 137.47C108.034 137.336 109.879 137.71 110.398 136.877C112.483 133.532 112.13 125.417 112.13 125.417C112.13 125.417 111.062 122.739 106.671 122.919C102.261 123.099 101.165 127.11 101.165 127.11Z",
    fill: "url(#paint14_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.199 130.571C102.199 130.571 101.274 129.519 100.402 129.399C99.5284 129.279 98.9592 131.559 100.151 132.999C101.341 134.437 102.715 133.176 102.715 133.176L102.199 130.571Z",
    fill: "url(#paint15_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.17 130.323C111.17 130.323 112.086 129.226 112.948 129.06C113.809 128.893 114.37 131.126 113.195 132.623C112.019 134.121 110.658 132.946 110.658 132.946L111.17 130.323Z",
    fill: "url(#paint16_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.475 130.511C101.592 130.722 101.725 130.918 101.815 130.892C102.189 130.784 100.747 127.172 102.075 125.86C102.761 125.182 103.534 125.764 106.338 125.566C109.154 125.366 109.873 124.672 110.722 125.168C111.495 125.62 112.186 126.949 111.613 130.951C111.773 130.91 111.932 130.868 112.091 130.827C111.877 129.527 112.111 128.696 112.379 128.17C112.574 127.786 112.928 127.288 112.9 126.584C112.883 126.147 112.739 126.131 112.716 125.774C112.646 124.726 113.835 124.414 113.892 123.376C113.936 122.577 113.253 122.412 113.378 121.575C113.484 120.863 114.017 120.719 113.933 120.208C113.842 119.657 113.127 119.262 112.625 119.129C112.113 118.994 111.928 119.161 111.628 118.959C111.142 118.632 111.375 118.029 111.024 117.814C110.399 117.431 109.154 119.04 108.349 118.664C107.861 118.436 108.049 117.72 107.617 117.556C106.782 117.24 105.304 119.624 104.709 119.325C104.424 119.182 104.699 118.603 104.299 118.189C103.83 117.704 102.702 117.729 102.187 118.265C101.707 118.765 102.114 119.341 101.606 119.973C101.15 120.54 100.622 120.323 100.106 120.781C99.2289 121.561 99.5344 123.272 99.6433 123.882C100.018 125.984 101.185 126.381 100.923 127.826C100.856 128.195 100.7 128.609 100.812 129.207C100.921 129.793 101.226 130.229 101.475 130.511Z",
    fill: "url(#paint17_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.185 125.684C112.082 124.655 112.876 124.156 112.742 123.424C112.635 122.835 111.972 122.32 111.348 122.221C110.016 122.011 109.152 124.006 107.825 123.825C106.797 123.684 106.911 122.434 105.75 121.96C103.906 121.207 101.971 123.682 100.741 123.038C100.371 122.845 99.9966 122.333 99.9699 120.922C99.2634 121.75 99.5407 123.307 99.6435 123.883C100.018 125.984 101.185 126.381 100.923 127.826C100.856 128.196 100.701 128.609 100.812 129.207C100.921 129.793 101.226 130.229 101.476 130.512C101.592 130.723 101.725 130.918 101.816 130.892C102.189 130.784 100.747 127.173 102.076 125.86C102.762 125.183 103.534 125.765 106.338 125.566C109.154 125.367 109.873 124.672 110.722 125.169C111.495 125.621 112.186 126.949 111.614 130.952C111.773 130.91 111.932 130.869 112.092 130.827C111.877 129.527 112.111 128.697 112.379 128.171C112.46 128.012 112.567 127.835 112.663 127.631C112.643 127.288 112.585 126.913 112.464 126.52C112.321 126.058 112.218 126.015 112.185 125.684Z",
    fill: "url(#paint18_linear_4226_12486)"
  })))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.857 89.7466C91.2723 90.3224 79.0151 78.4585 79.0151 63.2811C79.0151 48.1036 91.2723 36.0746 105.857 36.454C119.938 36.8204 131.038 48.6927 131.038 62.9308C131.038 77.1689 119.938 89.1907 105.857 89.7466Z",
    fill: "url(#paint19_linear_4226_12486)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M107.68 89.7334C93.122 90.3086 80.8872 78.4556 80.8872 63.292C80.8872 48.1285 93.122 36.1104 107.68 36.4892C121.735 36.8549 132.816 48.7164 132.816 62.9417C132.816 77.167 121.735 89.178 107.68 89.7334Z",
    fill: "url(#paint20_linear_4226_12486)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M131.133 62.951C131.133 76.2449 120.803 87.4065 107.681 87.8953C94.121 88.4004 82.792 77.3855 82.792 63.2772C82.792 49.1689 94.121 38.001 107.681 38.3232C120.803 38.6349 131.133 49.6572 131.133 62.951Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 40,
    width: 46,
    height: 47
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M129.442 62.9646C129.442 75.3002 119.845 85.6359 107.681 86.0615C95.1408 86.5003 84.6875 76.3002 84.6875 63.2666C84.6875 50.2329 95.1407 39.8918 107.681 40.1614C119.845 40.4229 129.442 50.6292 129.442 62.9646Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_4226_12486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.572 94.3172C128.227 97.5984 123.192 95.5996 108.021 95.8769C91.8819 96.1724 86.1627 98.3758 83.5614 94.8761C81.1605 91.6476 83.1498 79.9657 86.0073 76.6877C89.2431 72.9781 93.8656 71.8081 99.8343 71.3491C102.167 71.1695 104.704 71.0997 107.443 71.0275C110.055 70.9597 112.374 70.8976 114.457 70.9392C119.619 71.0421 123.334 71.7705 126.444 74.5655C130.508 78.2159 133.094 90.79 130.572 94.3172Z",
    fill: "url(#paint21_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.456 70.9392C114.445 71.1668 114.413 71.3912 114.361 71.6021C113.561 74.7909 111.809 81.4633 110.057 86.0844C108.848 89.2767 107.637 91.49 106.743 90.8954C106.042 90.4305 105.202 88.793 104.345 86.6363C102.607 82.2629 100.8 75.7444 99.9389 72.4997C99.8419 72.1383 99.8116 71.7315 99.8344 71.349C102.167 71.1694 104.704 71.0995 107.443 71.0273C110.055 70.9597 112.374 70.8976 114.456 70.9392Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.474 63.6719C103.474 63.6719 104.509 71.1386 103.078 71.8493L107.145 76.2976L111.248 71.0424C111.248 71.0424 109.699 69.8653 110.107 63.7083L103.474 63.6719Z",
    fill: "url(#paint22_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.562 74.7027L108.597 74.5898L107.644 77.3387L106.083 77.3408L105.562 74.7027Z",
    fill: "url(#paint23_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.057 86.1933C108.848 89.3857 107.637 91.5443 106.743 90.9497C106.042 90.4847 105.202 88.9297 104.345 86.773L106.083 77.3419L107.645 77.3398L110.057 86.1933Z",
    fill: "url(#paint24_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.188 58.2285C113.188 62.8372 110.477 67.8238 107.105 67.8678C103.702 67.9122 100.922 62.9164 100.922 58.2324C100.922 53.5484 103.702 51.012 107.105 51.0433C110.477 51.0742 113.188 53.6198 113.188 58.2285Z",
    fill: "url(#paint25_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.738 59.4161C101.08 59.3605 101.422 59.3051 101.763 59.2497C101.606 58.8666 100.959 57.1693 101.763 55.6855C102.534 54.2629 104.346 53.5778 105.727 53.6793C107.294 53.7943 108.232 54.5364 109.017 53.9695C109.457 53.6512 109.6 53.0695 109.65 52.6162C109.685 52.9066 109.764 53.3364 109.967 53.8119C110.549 55.177 111.533 55.4643 112.069 56.3658C112.429 56.9725 112.663 57.987 112.069 59.7736C112.365 59.7548 112.662 59.7361 112.958 59.7174C113.271 58.7146 113.646 57.2932 113.879 55.5543C114.225 52.9733 114.463 51.1972 113.481 50.3219C113.285 50.1475 112.418 49.4542 110.34 50.0763C109.852 49.5517 108.824 48.5887 107.239 48.0893C106.69 47.9163 103.963 47.057 101.539 48.8105C99.8866 50.0056 98.5894 52.2589 99.0065 54.1361C99.2271 55.1285 99.8299 55.5764 100.36 57.4939C100.584 58.3033 100.687 58.984 100.738 59.4161Z",
    fill: "url(#paint26_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.346 59.9317C112.346 59.9317 112.735 57.9116 113.917 58.1116C115.096 58.311 113.407 61.6202 112.346 62.0235V59.9317Z",
    fill: "url(#paint27_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.691 59.9612C101.691 59.9612 101.29 57.9123 100.067 58.1158C98.8412 58.3199 100.597 61.6841 101.691 62.0826V59.9612Z",
    fill: "url(#paint28_linear_4226_12486)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2663 159.82C40.0178 160.264 28.8965 149.92 28.8965 136.747C28.8965 123.574 40.0178 113.156 53.2663 113.513C66.072 113.858 76.1787 124.206 76.1787 136.591C76.1786 148.976 66.072 159.391 53.2663 159.82Z",
    fill: "url(#paint29_linear_4226_12486)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8611 159.757C41.6332 160.2 30.5293 149.864 30.5293 136.701C30.5293 123.538 41.6332 113.129 54.8611 113.485C67.6471 113.83 77.7382 124.171 77.7382 136.546C77.7382 148.922 67.6471 159.329 54.8611 159.757Z",
    fill: "url(#paint30_linear_4226_12486)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2044 136.551C76.2044 148.116 66.7977 157.787 54.861 158.162C42.54 158.549 32.2568 148.943 32.2568 136.696C32.2568 124.448 42.54 114.775 54.861 115.081C66.7977 115.378 76.2044 124.987 76.2044 136.551Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_4226_12486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 116,
    width: 42,
    height: 41
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6645 136.557C74.6645 147.287 65.9264 156.242 54.8612 156.567C43.4664 156.901 33.9771 148.006 33.9771 136.691C33.9771 125.375 43.4664 116.418 54.8612 116.677C65.9264 116.93 74.6645 125.827 74.6645 136.557Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_4226_12486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4188 151.457C37.2164 148.114 41.7239 146.801 42.2964 138.916C42.3353 138.381 43.0965 127.619 44.7914 125.514C45.0165 125.235 45.2673 125.012 45.2673 125.012C46.1134 124.353 47.4198 124.396 52.0679 122.392C56.0349 120.682 55.8061 120.734 56.3176 120.631C59.2892 120.029 63.667 122.592 65.1034 126.104C66.39 129.25 64.846 132.006 67.1518 137.525L67.1519 137.526C70.0034 145.461 71.4261 149.42 70.1385 151.986C66.2153 159.804 41.1129 158.947 38.4188 151.457Z",
    fill: "url(#paint31_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2568 151.657C32.2568 151.657 52.1423 140.005 76.2044 150.678C76.2044 150.678 73.1708 160.246 54.861 161.365C35.631 162.541 32.2568 151.657 32.2568 151.657Z",
    fill: "url(#paint32_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.374 136.629L50.6351 142.002C50.3829 143.837 49.0887 145.391 47.2855 146.019L41.2363 148.124C41.2363 148.124 52.7832 153.292 67.1839 147.606L60.6439 145.495C58.7798 144.843 57.5074 143.136 57.4261 141.17L57.2373 136.609L51.374 136.629Z",
    fill: "url(#paint33_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2961 131.89C60.2961 136.396 57.5224 141.263 54.0727 141.296C50.5917 141.328 47.7466 136.434 47.7466 131.854C47.7466 127.273 50.5917 124.802 54.0727 124.844C57.5224 124.886 60.2961 127.384 60.2961 131.89Z",
    fill: "url(#paint34_linear_4226_12486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5355 134.806C48.1384 134.774 47.2679 130.017 49.602 128.7C51.1485 127.827 53.8267 128.626 55.3298 130.175C57.6944 132.613 56.3721 136.122 58.1619 136.862C59.2964 137.331 60.809 136.321 61.5328 135.585C63.79 133.287 63.4826 128.438 60.813 125.691C58.6799 123.496 55.7775 123.397 55.0861 123.395C51.1191 123.379 47.4628 126.244 46.6227 129.646C45.9766 132.263 47.0893 134.83 47.5355 134.806Z",
    fill: "url(#paint35_linear_4226_12486)"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M159.331 108.936C159.071 108.94 158.845 108.727 158.845 108.459V100.349L53.2348 101.738V110.288C53.2348 110.57 53.038 110.802 52.7493 110.807C52.4605 110.813 52.2637 110.587 52.2637 110.305V101.203C52.2637 100.92 52.3278 100.767 52.6166 100.763L159.444 99.4102C159.703 99.4069 159.816 99.5489 159.816 99.8166V108.443C159.816 108.711 159.59 108.931 159.331 108.936Z",
    fill: "url(#paint36_linear_4226_12486)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M107.375 109.856C107.102 109.861 106.89 109.641 106.89 109.366V91.6424C106.89 91.3674 107.102 91.1429 107.375 91.1406C107.649 91.1384 107.861 91.3596 107.861 91.6344V109.35C107.861 109.625 107.649 109.851 107.375 109.856Z",
    fill: "url(#paint37_linear_4226_12486)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4226_12486",
    x1: 22.2083,
    y1: 139.375,
    x2: 111.795,
    y2: 201.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#BDC65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC65B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4226_12486",
    x1: 26.7716,
    y1: 79.9766,
    x2: 78.2797,
    y2: 173.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4338CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4226_12486",
    x1: 184.15,
    y1: 60.1221,
    x2: 136.503,
    y2: 158.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4338CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4226_12486",
    x1: 133.907,
    y1: 15.2924,
    x2: 135.058,
    y2: 122.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4226_12486",
    x1: 136.601,
    y1: 132.779,
    x2: 179.189,
    y2: 132.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4226_12486",
    x1: 138.078,
    y1: 133.232,
    x2: 180.603,
    y2: 133.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4226_12486",
    x1: 139.632,
    y1: 149.616,
    x2: 179.22,
    y2: 149.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4226_12486",
    x1: 159.353,
    y1: 134.803,
    x2: 159.432,
    y2: 150.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4226_12486",
    x1: 161.583,
    y1: 112.884,
    x2: 158.061,
    y2: 136.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#FDC49F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC49F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4226_12486",
    x1: 82.8745,
    y1: 134.59,
    x2: 127.783,
    y2: 134.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4226_12486",
    x1: 84.4326,
    y1: 135.054,
    x2: 129.273,
    y2: 135.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4226_12486",
    x1: 98.757,
    y1: 164.294,
    x2: 120.03,
    y2: 150.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4338CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4226_12486",
    x1: 106.699,
    y1: 145.889,
    x2: 106.53,
    y2: 135.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4226_12486",
    x1: 106.786,
    y1: 146.899,
    x2: 106.73,
    y2: 137.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4226_12486",
    x1: 106.034,
    y1: 135.394,
    x2: 107.508,
    y2: 117.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4226_12486",
    x1: 100.843,
    y1: 135.062,
    x2: 102.302,
    y2: 117.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4226_12486",
    x1: 111.942,
    y1: 135.703,
    x2: 113.415,
    y2: 117.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4226_12486",
    x1: 105.634,
    y1: 126.898,
    x2: 109.574,
    y2: 114.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4226_12486",
    x1: 105.645,
    y1: 126.866,
    x2: 109.613,
    y2: 114.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4226_12486",
    x1: 79.0151,
    y1: 63.106,
    x2: 131.038,
    y2: 63.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4226_12486",
    x1: 80.8872,
    y1: 63.117,
    x2: 132.816,
    y2: 63.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4338CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A256E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4226_12486",
    x1: 126.242,
    y1: 49.9926,
    x2: 98.9751,
    y2: 103.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4226_12486",
    x1: 105.818,
    y1: 63.9235,
    x2: 109.123,
    y2: 80.3695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4226_12486",
    x1: 105.562,
    y1: 75.9653,
    x2: 108.597,
    y2: 75.9653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4226_12486",
    x1: 104.345,
    y1: 84.1941,
    x2: 110.057,
    y2: 84.1941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4226_12486",
    x1: 109.546,
    y1: 42.9049,
    x2: 105.519,
    y2: 67.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4226_12486",
    x1: 107.426,
    y1: 48.0315,
    x2: 105.459,
    y2: 60.1805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4226_12486",
    x1: 115.813,
    y1: 44.0693,
    x2: 111.819,
    y2: 68.7292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4226_12486",
    x1: 103.677,
    y1: 41.7884,
    x2: 99.6158,
    y2: 66.8707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#4338CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E98E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4226_12486",
    x1: 28.8965,
    y1: 136.669,
    x2: 76.1786,
    y2: 136.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4226_12486",
    x1: 30.5293,
    y1: 136.624,
    x2: 77.7382,
    y2: 136.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4226_12486",
    x1: 83.5736,
    y1: 89.2612,
    x2: 27.7282,
    y2: 195.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4226_12486",
    x1: 54.2539,
    y1: 150.751,
    x2: 52.1366,
    y2: 188.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4226_12486",
    x1: 54.1616,
    y1: 138.447,
    x2: 54.243,
    y2: 154.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4226_12486",
    x1: 56.474,
    y1: 115.388,
    x2: 52.8008,
    y2: 140.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4226_12486",
    x1: 65.5443,
    y1: 110.89,
    x2: 44.2314,
    y2: 151.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4226_12486",
    x1: 52.2636,
    y1: 105.109,
    x2: 159.816,
    y2: 105.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4226_12486",
    x1: 106.89,
    y1: 100.498,
    x2: 107.861,
    y2: 100.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationUnify);
export default __webpack_public_path__ + "static/media/Illustration-unify.81bc105ea68a76cf649eb7aa15d21764.svg";
export { ForwardRef as ReactComponent };